export default __webpack_public_path__ + "static/media/no_image.a271556b.png";